import { REGULATED_SITE_HOSTS as REGULATED_SITE_HOSTS_FOR_ENV } from '@bfe/by-env';

// 优先使用sdk导入的，@bfe/by-env暂时作为兜底使用
export const REGULATED_SITE_HOSTS =
  (typeof window !== 'undefined' && window.RegulatedSiteHosts) ||
  REGULATED_SITE_HOSTS_FOR_ENV;

export const SUB_ATTRIBUTE = {
  // 母账号
  MAIN_ACCOUNT: 0,
  // 母账号
  NORMARL: 1,
  // 母账号
  ISLAMIC: 2,
  // 母账号
  BOT: 3,
  // 母账号
  COPY_TRADE: 4,
  // 母账号
  TRUSTEESHIP: 6,
  // 母账号
  DEMO: 8,
  // 母账号
  COPY_PRO: 9,
};
